<div *transloco="let t" fxLayout="column" fxLayoutGap="5px" fxLayoutAlign="start center">
  <span>{{ t(dayInString) }}</span>
  <div
    *ngFor="let hour of hourArrayDisplay; let first = first; let last = last"
    class="item-container"
    [ngStyle]="{ 'background-color': hour }"
    [ngClass]="{ last: last, first: first }"
  ></div>
</div>
